<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div
	class="splash-loader-layer splash-loader-light"
	[ngStyle]="{ position: displayGlobally ? 'fixed' : 'absolute' }"
>
	<div class="centering-wrapper sl-icon">
		<div class="loading-x material-icons">close</div>
	</div>
	<div class="centering-wrapper sl-spinner no-spin error">
		<div class="splash-spinner"></div>
	</div>
</div>
